'use strict';

(function ($, FUNCTIONS) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	// ＜ルート設定対応＞要素が空だったら削除
	var removeElmIfEmpty = function removeElmIfEmpty() {
		$('.js-checkEmptyElm').each(function (idx, val) {
			if (!$(val).text().length) {
				$(val).remove();
			}
		});
	};
	// ＜ルート設定対応＞該当のリストにルート設定出力が0件の場合、指定する親ブロックごと削除する
	var removeBlockIfListEmpty = function removeBlockIfListEmpty() {
		if ($('.js-checkEmptyList').length) {
			$('.js-checkEmptyList').each(function (idx, val) {
				if (!$(val).find('li').length) {
					$(val).parents('.js-checkEmptyList-wrap').remove();
				}
			});
		}
	};
	var share = function share() {
		if ($('.mod-share').length) {
			var pageUrl = document.URL;
			var shareUrl = "";
			var sharePagetitle = document.title;
			// facebook
			if ($('.mod-share ._facebook').length) {
				shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
				$('.mod-share ._facebook').attr('href', shareUrl);
			}
			// twitter
			if ($('.mod-share ._twitter').length) {
				shareUrl = 'https://twitter.com/share?text=' + sharePagetitle + '&url=' + pageUrl;
				$('.mod-share ._twitter').attr('href', shareUrl);
			}
			// line
			if ($('.mod-share ._line').length) {
				shareUrl = 'https://social-plugins.line.me/lineit/share?url=' + pageUrl;
				$('.mod-share ._line').attr('href', shareUrl);
			}
			// mail
			if ($('.mod-share ._mail').length) {
				shareUrl = 'mailto:?body=' + pageUrl;
				$('.mod-share ._mail').attr('href', shareUrl);
			}
		}
	};
	removeElmIfEmpty();
	removeBlockIfListEmpty();
	share();
})(window.jQuery, window.FUNCTIONS);